import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Tabs, Tooltip } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import GetPositionPerformanceApi from "../../api/individuals/GetPositionPerformanceApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import PositionPerformanceOverview from "../../components/positionPerformance/PositionPerformanceOverview";
import PositionPerformanceObjectives from "../../components/positionPerformance/PositionPerformanceObjectives";
import PositionPerformanceHierarchy from "../../components/positionPerformance/PositionPerformanceHierarchy";
import { getPluralString } from "../../helpers/wordHelpers";

const { TabPane } = Tabs;

function PositionPerformance() {
  const proHeight = document.body.clientHeight;
  const [data, setData] = useState();
  const topPlanState = useSelector((state) => state.topPlanState.value);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  let curLocation = useLocation();

  useEffect(() => {
    getPositionsData();
  }, [curLocation, perfCycleState]);

  async function getPositionsData() {
    let path = curLocation.pathname;
    let id = path.split("/positions-performance/");
    const apiResponse = await GetPositionPerformanceApi(
      id[1],
      perfCycleState.id
    );

    if (apiResponse.message === "success") {
      setData(apiResponse.data);
    }
  }

  const left = (
    <>
      <div className="flex items-baseline">
        <Link to="/positions-performance">
          <div className="text-sm pri-font text-gray-400 hover:text-gray-500">
            Positions
          </div>
        </Link>
        <div className="mx-1 text-lg">/</div>
        <div className="text-lg pri-font max-w-xs truncate">
          {data
            ? `${data?.designation?.abbreviation} (${data?.unit?.name})`
            : "..."}
        </div>
      </div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Tabs defaultActiveKey="1" centered>
            <TabPane
              tab={<div className="w-32 text-center">Overview</div>}
              key="1"
            >
              <div className="px-6">
                <PositionPerformanceOverview />
              </div>
            </TabPane>
            <TabPane
              tab={
                <div className="w-32 text-center">
                  {getPluralString(topPlanState) || "Top plans"}
                </div>
              }
              key="2"
            >
              <div className="px-6">
                <PositionPerformanceObjectives />
              </div>
            </TabPane>

            {/* <TabPane
              tab={
                <div
                  // onClick={() => setHierarchy(true)}
                  className="w-32 text-center"
                >
                  Hierarchy
                </div>
              }
              key="4"
            >
              <div className="px-6">
                <PositionPerformanceHierarchy />
              </div>
            </TabPane> */}
          </Tabs>
        </div>
      </Content>
      {/* <PositionHierarchy
        visible={hierarchy}
        onClose={() => setHierarchy(false)}
      /> */}
    </>
  );
}

export default PositionPerformance;
